export enum SectionName {
  // base
  GameInProgress = 'Game In Progress',
  NotFound = 'Not Found',
  Unavailable = 'Unavailable',

  // any user
  Analytics = 'Analytics',
  HitterLibrary = 'Hitter Library',
  Pitches = 'Pitches',
  VideoLibrary = 'Video Library',

  // any admin
  AdminPortal = 'Admin Portal',

  // super admin
  FeatureDemo = 'Feature Demo',

  // trajekt staff only
  PlatformConsole = 'Platform Console',
}

export enum SubSectionName {
  // pitches
  GameData = 'Game Data',
  Library = 'Library',
  Design = 'Design',
  List = 'List',
  Lists = 'Lists',
  Upload = 'Upload',

  // admin portal
  Users = 'Users',
  Machines = 'Machines',
  Organizations = 'Organizations',
  BallTypes = 'Ball Types',
  MachineModels = 'Machine Models',
  ErrorTypes = 'Error Types',
  StaticVideos = 'Static Videos',
  ApiKeys = 'API Keys',
  ServerControls = 'Server Controls',
  ServerErrors = 'Server Errors',

  // platform console
  FeatureFlags = 'Feature Flags',
  Jobs = 'Jobs',

  // analytics
  HittingReports = 'Hitting Reports',
  SessionHistory = 'Session History',

  // hitter library
  Hitters = 'Hitters',
  HitterProfile = 'Hitter Profile',

  // shared
  HitterSession = 'Hitter Session',
}
